export default {
    si:'Yes'
    ,no:'No'
    ,errore:'Error'
    ,modifica:'Edit'
    ,salvainvia:'Save and send'
    ,warning:'WARNING'
    ,aggiungi:'Add'
    ,salvamodifiche:'Save'
    ,cancella:'Cancel'
    ,esito:'status of abstract'
    
    

    
    ,referenteBiomedia:'BIOMEDIA CONTACT PERSON'
    ,programma:'PROGRAMME'
    ,prenotazioneAlberghiera:'HOTEL AND TRAVEL ACCOMMODATION'
    ,inEvidenza:'Highlights'
    ,iscriviti:'REGISTER HERE'
    ,iscrizioniAziende:'COMPANY SIGN UP'
    ,responsabileScientifico:'SCIENTIFIC DIRECTOR'
    ,modalitaIscrizione:'REGISTRATION FEE'
    ,tornaCalendario:`back to event's calendar`
    ,eventi:'Events'
    ,creditiEcm:'ECM credits'
    ,visualizzaGallery:'SHOW THE GALLERY'

    ,leQuote:'THE REGISTRATION FEES ARE THE FOLLOWING'
    ,infoPrestoDisponibili:'Information available soon'


    ,testo:'Text'
    ,titolo:'Title'
    ,parolechiave:'Keywords'
    ,parolechiaveHolder: "Text 3 or more keywords"
    ,cognome:'surname'
    ,nome:'name'
    ,email:'email'
    ,cellulare:'Mobile Phone'
    ,affiliazione:'Affiliation'
    ,scegliere_lista:'Choose from list'
    ,scegliere_topic:'Choose topic from list'
    ,codiceconsultazione:'consultation code '
    ,codicefiscale: 'Fiscal Code'
    ,socio:'Member'
    ,nazionelavoro:'Working State'
    ,regionelavoro:'Working Region'
    ,categoriaprofessionale:'Profession'
    ,annonascita:'Year of birth'
    

    ,assistenzaSection:'ASSISTENCE'
    ,assistenzaHelp:`For further assistence, please contact:`

    ,lineeguidaSection:'GuideLines'
    ,lineeguidaCheck:' I saw the guidelines and I accept to send the abstract'

    ,datipresentatoreSection:'PRESENTER INFORMATION'
    ,datipresentatoreHelp: 'The presenter is the contact person for the communication of the abstract'

    ,affiliazioniSection:'AFFILIATIONS'
    ,affiliazioniHelp:`Write in lower case with uppercase initials without pointing the street (i.e. Clinical Biochemistry Lab, Osp. Fatebenefratelli, Milan)
    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">»</div><div class="col s11m">The same affiliation must be used just once</div></div>
    <div class="row pad"><div class="col sm yo-align-right">»</div><div class="col s11m">Use one line for each affiliation</div></div>
    <div class="row pad"><div class="col sm yo-align-right">»</div><div class="col s11m">Use abbreviations (i.e. Dep.)</div></div>`
    ,affiliazioniOrderHelp:`To change the order of affiliations just drag and place the affiliate position to the correct position 
    <br />
    To change or delete any of the affiliates you have already inserted, click on the affiliate you want to edit, and proceed with the changes.`

    ,autoriSection:'AUTHORS'
    ,autoriHelp:`Write the full name with the first letter in capital
    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">1</div><div class="col s11m">Write the name and surname of the first author</div></div>
    <div class="row pad"><div class="col sm yo-align-right">2</div><div class="col s11m">From the drop-down list, select the affiliate or the affiliations of reference from the ones previously inserted</div></div>
    <div class="row pad"><div class="col sm yo-align-right">3</div><div class="col s11m">Confirm your data with   <i class="el-icon-plus"></i> or if you are changing the data of an author already inserted with <i class="el-icon-edit"></i> </div></div>`
    ,autoriOrderHelp:`To change the order of affiliations just drag and place the affiliate position to the correct position
    <br />
    To change or delete any of the affiliates you have already inserted, click on the affiliate you want to edit, and proceed with the changes.`

    ,paSection:'FIRST AUTHOR'

    ,datiabsSection:'ABSTRACT INFORMATION'
    ,datiabsOrale:`Do you want to submit your abstract as oral communication?`
    ,datiabsPoster:`Do you want to submit your abstract as Poster?`
    ,datiabsPosterNoOrale:`If your abstract will not be accepted as oral communication, do you want to submit it as a poster?`

    ,testoSection:'TITLE AND TEXT'
    ,titoloolder:'Text a title for abstract'
    ,maxparoleWarning:`Exceeded the maximum number of words that is`

    ,datitestoHelp:`Se doveste avere problemi ad incollare il vostro testo dal programma MS word, vi consigliamo di passare dal blocco note prima di incollare nel gestionale.
    <br />Potete anche provare ad incollare il testo con la combinazine di caratteri CTRL+SHIFT+v`

    ,previewSection:'PREVIEW AND SEND'
    ,previewHelp:`Click on PREVIEW to see you abstract.
    <br />
    Once you have check your abstract, please accept the preview .
    <br />
    Until you send the abstract this will not be valid.`
    ,previewCheck:'Ho preso visione della preview'
    ,previewCheckHelp:`To send your own abstract you must first tick the preview box and accept the preview.
    <br />
    If you want to make changes, press the "Edit" button`
    ,previewCheckedHelp:`Congratulation,now you can send the abstract!`


    ,eRequired:{
        premail:'email address of presenter is mandatory'
        ,prcognome:'surname of presenter is mandatory'
        ,prnome:'name of presenter is mandatory'
        ,paemail:'email of the first author is mandatory'
        ,pacellulare:'mobile phone of the first author is mandatory'
        ,pacodicefiscale:'Fiscal Code Only for italian participants'
        ,panato:'Year of birth of the first author is mandatory'
        ,pacategoriaprofessionale:'Profession of the first author is mandatory'
        ,paregionelavoro:'Working region of the first author is mandatory'
        ,panazionelavoro:'Nationality of the first author is mandatory'
        ,paassociazione:'Please flag if the first author is member or not member'
        ,poster:'Poster is mandatory'
        ,topicposter:'Topic for poster is mandatory'
        ,comunicazione:'Oral communication is mandatory'
        ,topiccomunicazione:'Topic for oral communication is mandatory'
        ,titolo:'title is mandatory'
        ,parolechiave:'Key words are mandatory'
        ,codiceconsultazione: 'consultation code is mandatory'
    }

    ,eEmail:'email address is not correct'

}



// WEBPACK FOOTER //
// ./src/teras/en.js